import { Category } from "app/components/class/category/category";
import { Product } from "app/components/class/product/product";
import { Rename } from "app/components/class/rename/rename";
import { SingService } from "app/components/service/sing.service";
import { Injectable } from "@angular/core";
@Injectable()
export class RenameService {
    indexCat: number = 0;
    indexProduct: number = 0;
    categori: Category;
    product: Product;
    editProduct: boolean = false;
    editCategori: boolean = false;
    constructor (private httpService: SingService) {

    }
    public show (){
        (<HTMLElement>document.body.querySelector(".allwhite")).style.display = "block";
        document.body.querySelector("main").classList.add("m--blur");
    }
    public updateCategory (data:Rename) {
       return  this.httpService.updateCategory(data);
    }
    public updateProduct (data:Rename) {
        return   this.httpService.updateProduct(data);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/rename/services/rename.service.ts